import React, { Component, Fragment } from "react";
import { Paper } from "material-ui";
import Table, {
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    TableFooter
} from "material-ui/Table";
import {
    formatSurveys
} from "../../utils/utils";
import { connect } from "react-redux";

class PaginatedTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pageRows: props.defaultLimit || 15,
            rowsPerPageOptions: [15, 30, 50, 100]
        };
    }

    handleChangePage = (event, page) => {
        if (event !== null && page !== undefined)
            this.props.updateItems(
                page * this.state.pageRows,
                this.state.pageRows,
                page
            );
    };

    handleRowsPerPage = event => {
        const { defaultPage } = this.props;
        this.setState({ pageRows: event.target.value }, () => {
            this.props.updateItems(
                defaultPage,
                this.state.pageRows,
            );
        });
    };

    render() {
        const { itemList, rows, columns, noResultsText, defaultPage } = this.props;
        const { consultTypes, countries, provinces } = this.props.main;
        const { pageRows, rowsPerPageOptions } = this.state;
        const emptyRows =
            pageRows - Math.min(pageRows, rows - defaultPage * pageRows);
        let builtItems = formatSurveys(itemList, consultTypes, countries, provinces);
        return (
            <Fragment>
                <Paper style={{ width: "100%" }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                {columns.map(column => {
                                    return (
                                        <TableCell
                                            style={{
                                                padding: "5px",
                                                textAlign: "center",
                                                width: column.name === 'office_name' ? "20%" : column.name === 'duration' ? "3%": "8%"
                                            }}
                                            key={`header_${column.name}`}>
                                            {column.title}
                                        </TableCell>
                                    );
                                })}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {builtItems.length > 0 ? (
                                builtItems.map(item => {
                                    return (
                                        <TableRow
                                            hover
                                            style={{ cursor: "pointer" }}
                                            key={item.id}
                                            onClick={() => {
                                                this.props.openSurvey(item);
                                            }}>
                                            {columns.map(column => {
                                                return (
                                                    <TableCell
                                                        style={{
                                                            padding: "4px",
                                                            textAlign: "center",
                                                            width: column.name === 'office_name' ? "20%" : column.name === 'duration' ? "3%": "8%"
                                                        }}
                                                        key={`cell_${column.name}_${item.id}`}>
                                                        {item[column.name]}
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    );
                                })
                            ) : (
                                    <TableRow>
                                        <TableCell
                                            colSpan={columns.length}
                                            style={{
                                                textAlign: "center",
                                                color: "#333",
                                                fontSize: "1.3rem"
                                            }}>
                                            {noResultsText}
                                        </TableCell>
                                    </TableRow>
                                )}
                            {/* {emptyRows > 0 && (
                                <TableRow style={{ height: 48 * emptyRows }}>
                                    <TableCell colSpan={columns.length} />
                                </TableRow>
                            )} */}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    colSpan={columns.length}
                                    count={+rows}
                                    rowsPerPage={pageRows}
                                    page={defaultPage}
                                    onChangePage={this.handleChangePage}
                                    labelRowsPerPage="Resultados por páxina"
                                    onChangeRowsPerPage={this.handleRowsPerPage}
                                    rowsPerPageOptions={rowsPerPageOptions}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </Paper>
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    main: state.main
});

export default connect(
    mapStateToProps,
    null
)(PaginatedTable);



// WEBPACK FOOTER //
// ./src/components/displayComponents/PaginatedTable.js